import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
} from "@/components/molecules/responsive-dialog";
import { Button } from "@/components/ui/button";
import { DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { EmailChallenge } from "@/views/login/challenges/email";
import { useTranslation } from "@/features/utils/i18n";

interface AddEmailDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: (preSignedToken: string) => void;
}

export const AddEmailDrawer = ({
  open,
  onOpenChange,
  onSuccess,
}: AddEmailDrawerProps) => {
  const { t } = useTranslation();

  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent className="sm:max-w-md">
        <ResponsiveDialogHeader>
          <DialogTitle>{t("security.emailAddresses.addTitle")}</DialogTitle>
          <DialogDescription>
            {t("security.emailAddresses.addDescription")}
          </DialogDescription>
        </ResponsiveDialogHeader>

        <EmailChallenge
          onSuccess={(preSignedToken) => {
            onSuccess(preSignedToken);
            onOpenChange(false);
          }}
        />

        <ResponsiveDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};
